import { SelectAsyncInput } from '@core/components/Select';
import { parseHeaderForLinks } from '@core/util';
import grupoAcessoApi from 'app/services/api/grupoAcessoApi';
import React from 'react';

const SelectGrupoAcesso = ({ id, handleChange, value, handleBlur, error, touched, required }) => {
  return (
    <SelectAsyncInput
      id={id}
      required={required}
      name={id}
      label="Grupo de acesso"
      value={value}
      onChange={(event, valor) => {
        handleChange({
          target: {
            id,
            value: valor,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={handleBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option.nome;
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await grupoAcessoApi.pesquisar({
          size: 100,
          sort: 'nome',
          page: next,
          q: query,
        });
        const links = parseHeaderForLinks(response.headers.link);
        const totalItems = response.headers['x-total-count'];
        const data = response?.data || [];

        return { data, nextPage: links.next, totalItems };
      }}
      fetchOnFocus
    />
  );
};

export default SelectGrupoAcesso;
